module.exports = __webpack_public_path__ + "r-v3/img/sticker_8.18d36277.svg";